<template>
  <g class="not-copy">
    <g>
      <foreignObject :x="x" :y="y" height="48" width="48">
        <img :style="transform" src="@/assets/virtualoffice/interior/bk_chair.png" class="img-icon" xmlns="http://www.w3.org/1999/xhtml"/>
      </foreignObject>
    </g>
    <rect :x="x" :y="y" height="48" width="48" fill="transparent" @dblclick="sitDown(x, y)" @contextmenu.prevent="openContextMenu($event, x, y)"/>
  </g>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Chair',
  componentName: 'Chair',
  props: ['x', 'y', 'transform', 'table'],
  methods: {
    sitDown (x, y) {
      let tempOfficeStatus = {
        type   : 'user',
        officeX: x,
        officeY: y,
        room   : this.table.pk
      }
      console.log(tempOfficeStatus)
      this.$store.dispatch('virtualOffice/setVirtualOfficeSV', tempOfficeStatus)
    },
    openContextMenu (event, x, y) {
      let tempRoomStatus = {
        officeX: x,
        officeY: y,
        room   : this.table.pk
      }
      this.$store.dispatch('virtualOffice/setRoomStatus', tempRoomStatus)
      var menu = document.getElementById("context-menu")
      console.log("###0###", event)
      if(!this.contextMenuWidth || !this.contextMenuHeight) {
        menu.style.visibility = 'hidden'
        menu.style.display = 'block'
        this.contextMenuWidth = menu.offsetWidth
        this.contextMenuHeight = menu.offsetHeight
        menu.removeAttribute('style')
      }
      var tepmViewY = 0
      if (this.isTemplateView){
        tepmViewY = 50
      }
      if((this.contextMenuWidth + event.pageX) >= window.innerWidth) {
        menu.style.left = (event.layerX - this.contextMenuWidth) + 5 + 'px'
      } else {
        menu.style.left = event.layerX + 5 + 'px'
      }
      if((this.contextMenuHeight + event.offsetY) >= window.innerHeight) {
        menu.style.top = (event.layerY - this.contextMenuHeight) + tepmViewY + 5 + 'px'
      } else {
        menu.style.top = event.layerY + tepmViewY + 5 + 'px'
      }
      menu.classList.add('active')
    }
  }
}
</script>

<style lang="scss" scoped>
.img-icon {
  width: 48px;
  height: 48px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/VirtualOffice/Interior/Chair.vue